import React from 'react';
import { useNavigate } from 'react-router-dom';
import { coachPaths } from '../../routes/coach';
import { enterPrisesPaths } from '../../routes/enterprises';

const SuccessCreatePassword = () => {
    const navigate = useNavigate();

    return (
        <div
            style={{
                backgroundColor: "#f5f5f5",
                minHeight: "100vh",
                margin: 0,
                fontFamily: "'Lato', Helvetica, Arial, sans-serif",
                paddingBlock: "40px",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"
            }}
        >
            <link
                href="https://fonts.googleapis.com/css?family=Lato:400,700"
                rel="stylesheet"
            />
            <table width="100%" cellPadding="0" cellSpacing="0">
                <tbody>
                    <tr>
                        <td align="center">
                            <table width="100%" style={{ maxWidth: 600 }}>
                                <tbody>
                                    <tr>
                                        <td
                                            align="center"
                                            style={{
                                                backgroundColor: "#ffffff",
                                                padding: "0px 0px 10px",
                                                borderRadius: "4px 4px 0 0",
                                                fontSize: 24,
                                                fontWeight: 700,
                                                color: "#111",
                                                lineHeight: "32px",

                                            }}
                                        >
                                            <div style={{
                                                marginBottom: "30px", backgroundColor: "#e6e6e6", width: "100%", paddingTop: "14px"
                                            }}>
                                                <img
                                                    src="https://api.nu-vio.com:4005/logo.png"
                                                    alt="Nuvio Logo"
                                                    style={{
                                                        border: 0, maxWidth: "83px",
                                                        width: "100%",
                                                        objectFit: "contain"
                                                    }}
                                                />
                                            </div>
                                            <img
                                                src="https://api.nu-vio.com:4005/success-chk.png"
                                                width="100"
                                                alt="Success"
                                                style={{
                                                    display: "block",
                                                    marginBottom: 20,
                                                }}
                                            />
                                            <p style={{ marginBottom: "0px" }}>Password Set Successful</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            align="center"
                                            style={{
                                                backgroundColor: "#ffffff",
                                                padding: "0 30px 30px",
                                                fontSize: 18,
                                                color: "#666",
                                                lineHeight: "28px",
                                            }}
                                        >
                                            <p style={{ margin: 0 }}>
                                                Your password has been successfully set. You can now log
                                                in using your new password.
                                            </p>
                                            <div style={{ marginTop: "20px" }}>
                                                <button
                                                    className='ct_yellow_btn ct_darkblue_btn px-5'
                                                    onClick={() => navigate(enterPrisesPaths?.Enterprise)}
                                                >
                                                    Continue to Nuvio
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            align="left"
                                            style={{
                                                backgroundColor: "#ffffff",
                                                padding: "0 30px 30px",
                                                borderRadius: "0 0 4px 4px",
                                                fontSize: 18,
                                                color: "#666",
                                                lineHeight: "25px",
                                            }}
                                        >
                                            <p style={{ margin: 0 }}>
                                                Cheers,
                                                <br />
                                                <span style={{ fontWeight: "600", color: "#000" }}>Nuvio Team</span>
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td align="center" style={{ padding: "0px 10px" }}>
                            <table width="100%" style={{ maxWidth: 600 }}>
                                <tbody>
                                    <tr>
                                        <td
                                            align="center"
                                            style={{
                                                backgroundColor: "rgb(2 48 71)",
                                                padding: 30,
                                                borderRadius: 4,
                                                fontSize: 16,
                                                color: "#fff",
                                                lineHeight: "24px",
                                            }}
                                        >
                                            <h2
                                                style={{
                                                    fontSize: 16,
                                                    fontWeight: 700,
                                                    margin: 0,
                                                }}
                                            >
                                                Need help?
                                            </h2>
                                            <p style={{ margin: "5px 0 0" }}>
                                                <a
                                                    onClick={() =>
                                                        navigate(coachPaths.ContactUs, { state: { data: "landing" } })
                                                    }
                                                    style={{
                                                        color: "#fff",
                                                        textDecoration: "none",
                                                    }}
                                                >
                                                    Contact our support team
                                                </a>
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default SuccessCreatePassword;